import { CellHoverButtonsButton, type CellHoverButtonsButtonProps } from './button'

interface CellHoverButtonsPrimaryProps extends Omit<CellHoverButtonsButtonProps, 'variant' | 'tone'> {
  /** Brand yellow for actions and reminders; the inverse fill for meeting cells. */
  tone?: 'brand' | 'meeting'
}

/** The cluster's one filled button — the cell's headline move (invoke, mark done, join). */
export function CellHoverButtonsPrimary({ tone = 'brand', ...props }: CellHoverButtonsPrimaryProps) {
  return <CellHoverButtonsButton variant="primary" tone={tone === 'meeting' ? 'inverse' : 'neutral'} {...props} />
}
